export default [
  {
    name: 'seating',
    path: '/seating',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Seating',
      icon: 'dvr',
      label: 'Seating',
      roles: ['Admin']
    }
  }
]
